// extracted by mini-css-extract-plugin
module.exports = {"modalRoot":"_1Sx0R","container":"_1bPZi","centered":"_31y7a","content":"_1uZ3F","fromBottom":"iIxTx","fromRight":"_3v9Zb"};